module.exports = __webpack_public_path__ + "img/ie.c68ff961.svg";